import { initExpandable, expandContainer, collapseContainer, setExpandableHeight } from 'allink-core-static/js/modules/expandable';

$(function(){

    // container
    var category_selection_class = 'work-category-selection-plugin';
    var category_selection_selector = '.'+category_selection_class;
    // select level 1
    var category_selection_select_level_1_class = category_selection_class+'__select-level-1';
    var category_selection_select_level_1_selector = 'select.'+category_selection_select_level_1_class;
    // select level 2
    var category_selection_select_level_2_class = category_selection_class+'__select-level-2';
    var category_selection_select_level_2_selector = 'select.'+category_selection_select_level_2_class;
    var category_selection_select_level_2_parent_prefix_class = 'parent-';
    var category_selection_select_level_2_option_selector = '.select-level-2-option';
    var category_selection_select_level_2_container_class = category_selection_class+'__select-level-2-container';
    var category_selection_select_level_2_container_selector = '.'+category_selection_select_level_2_container_class;
    var category_selection_select_level_2_container_visible_class = category_selection_select_level_2_container_class+'--visible';
    // products
    var category_selection_content_class = 'work-category-selection-plugin-content';
    var category_selection_content_selector = '.'+category_selection_content_class;
    var category_selection_content_col_class = category_selection_content_class+'__col';
    var category_selection_content_col_selector = '.'+category_selection_content_col_class;
    var category_selection_content_col_hidden_class = category_selection_content_col_class+'--hidden';
    var category_selection_content_list_class = category_selection_content_class+'__list';
    var category_selection_content_list_selector = '.'+category_selection_content_list_class;
    var category_selection_content_item_class = category_selection_content_class+'__list-item';
    var category_selection_content_item_visible_class = category_selection_content_class+'--visible';
    var category_selection_content_item_selector = '.'+category_selection_content_item_class;

    // changing level 1
    $(category_selection_select_level_1_selector).on('change',function(){
        // init
        var $selected_item = $(this);
        var selection_id = $selected_item.val();
        // first, hide all products
        resetLevel2Visibility()
        // then, hide all products
        resetProductVisibility()
        // collapse container: level 2
        var $container = $(category_selection_select_level_2_container_selector);
        collapseContainer($container);
        // collapse container: products
        var $container = $(category_selection_content_selector);
        collapseContainer($container);
        // only display level 2, if this item has kids
        if (hasLevel2Items(selection_id)) {
            // show kids of selected ID
            setLevel2Visibility(selection_id);
        }
        // otherwise, skip level 2 and display products directly
        else {
            // show kids of selected ID
            setProductVisibility(selection_id);
        }

    });

    // changing level 2
    $(category_selection_select_level_2_selector).on('change',function(){
        // init
        var $selected_item = $(this);
        var selection_id = parseInt($selected_item.val());
        // first, hide all products
        resetProductVisibility()
        // show kids of selected ID
        setProductVisibility(selection_id);
        // re-calculate height delayed
        setTimeout(function(){
            setExpandableHeight();
        },0);
    });

    function hasLevel2Items(selection_id) {
        return $(category_selection_select_level_2_option_selector).hasClass(category_selection_select_level_2_parent_prefix_class+selection_id);
    }

    function resetLevel2Visibility() {
        // reset value of bootstrap-select:
        // https://silviomoreto.github.io/bootstrap-select/methods/
        $(category_selection_select_level_2_selector).selectpicker('val','');
        // we have to destroy and render the select
        $(category_selection_select_level_2_selector).selectpicker('destroy');
        $(category_selection_select_level_2_selector).selectpicker('render');
        // additionally, we have to clean the markup again and mark it as initialized
        $('.bootstrap-select .dropdown-toggle').each(function(){
            this.innerHTML = this.innerHTML.replace(/&nbsp;/g,'');
            $(this).find('.bs-caret').remove();
            $(this).addClass('toggle-initialized');
        });
    }

    function setLevel2Visibility(selection_id) {
        // init
        var parent_class = category_selection_select_level_2_parent_prefix_class+selection_id;
        var $level_2_items = $(category_selection_select_level_2_option_selector);
        // loop
        $level_2_items.each(function(i){
            var $item = $(this);
            if ($item.hasClass(parent_class)) {
                $item.parents('li').show();
            }else {
                $item.parents('li').hide();
            }
        });
        // re-init expandable height
        initExpandable();
        // set container to visible using our 'extandable' plugin
        var $container = $(category_selection_select_level_2_container_selector);
        expandContainer($container);
        // re-calculate height
        setExpandableHeight();
    }

    function resetProductVisibility() {
        // hide products
        $(category_selection_content_item_selector).hide();
        // set container to invisible
        $(category_selection_content_selector).removeClass(category_selection_content_item_visible_class);
    }

    function setProductVisibility(selection_id) {
        // init
        var $items = $(category_selection_content_item_selector);
        // set container to visible
        $(category_selection_content_selector).addClass(category_selection_content_item_visible_class);
        // loop through items
        $items.each(function(i){
            // init
            var match = false;
            var $item = $(this);
            // get object with parent IDs
            var item_parent_obj = $item.data('parent-categories')
            for (var i = item_parent_obj.length - 1; i >= 0; i--) {
                // init
                var parent_id = item_parent_obj[i];
                // set flag to true if we have a match
                if (selection_id == parent_id) {
                    match = true;
                }
            }
            // match? show item
            if (match === true) {
                $item.show();
            }
        });
        // loop through the product lists and hide lists that have no visible items
        $(category_selection_content_col_selector).each(function(){
            let $column = $(this);
            let $visible_children = $column.find(category_selection_content_item_selector+':visible');
            if ($visible_children.length > 0) {
                $column.removeClass(category_selection_content_col_hidden_class);
            }else {
                $column.addClass(category_selection_content_col_hidden_class);
            }
        });
        // re-init expandable height
        initExpandable();
        // set container to visible using our 'extandable' plugin
        var $container = $(category_selection_content_selector);
        expandContainer($container);
        // re-calculate height
        setExpandableHeight();
    }

});



// WEBPACK FOOTER //
// ./static/js/modules/category-selection.js